// stores/columnStore.ts
import { defineStore } from "pinia"

export const useColumnStore = defineStore("columnStore", {
  state: () => ({
    columnConfigs: {} as Record<string, any[]>
  }),

  persist: true,   // 🔥 THIS is all you need with your plugin

  actions: {
    setColumns(endpoint: string, columns: any[]) {
      if (!endpoint) return
      // Persist only user-controlled presentation state. Full column specs can
      // contain large option arrays and belong to the server-provided spec.
      this.columnConfigs[endpoint] = columns.map((column: any) => ({
        key: column.key,
        show: column.show !== false,
        width: column.width ?? 150,
        sticky: column.sticky ?? 0,
      }))
    },

    getColumns(endpoint: string) {
      if (!endpoint) return undefined
      return this.columnConfigs[endpoint]
    },

    cleanupStaleKeys() {
      delete this.columnConfigs["undefined"]
      delete this.columnConfigs["null"]
      Object.entries(this.columnConfigs).forEach(([endpoint, columns]) => {
        if (!Array.isArray(columns)) {
          delete this.columnConfigs[endpoint]
          return
        }
        this.setColumns(endpoint, columns)
      })
    }
  }
})
